import api from '@/api'

export default class PaymentApi {
	static async cryptoGet(data) {
		return api.post('/payments/crypto-get', data).then(function (response) {
			return response.data
		})
	}

	static async cryptoCreate(data) {
		return api.post('/payments/crypto-create', data).then(function (response) {
			return response.data
		})
	}

	static async cryptoToBot(data) {
		return api.post('/payments/crypto-to-bot', data).then(function (response) {
			return response.data
		})
	}

	static async tinkoffGet(data) {
		return api.post('/payments/tinkoff-get', data).then(function (response) {
			return response.data
		})
	}

	static async tinkoffCreate(data) {
		return api.post('/payments/tinkoff-create', data).then(function (response) {
			return response.data
		})
	}
}
